import React from "react";
import { Navbar, Footer } from "../components";
import FotoHeader from "../assets/2FotoPabrik.jpeg";
import { Aplikasi } from "../components/Career";
import { Header } from "../components/CoilAbuPage.jsx";

const CoilAbu = () => {
  const BgHeader = {
    backgroundImage: `url(${FotoHeader})`,
    backgroundSize: "cover",
    backgroundPosition: "0% 60%",
    overflow: "hidden",
  };
  return (
    <>
      <Navbar />
      <section style={BgHeader}>
        <div className="text-left bg-black/80 text-white px-10 py-5 lg:px-36">
          <h1 className="text-3xl font-bold lg:text-5xl">Career</h1>
          <p className="mt-5 text-justify">
            <span className="font-bold">
              Bergabunglah bersama PT Pandawa Jaya Steel
            </span>{" "}
            – perusahaan yang terus tumbuh dan berkomitmen dalam menghadirkan
            produk baja berkualitas tinggi untuk mendukung pembangunan
            Indonesia. Kami mencari individu yang berdedikasi, penuh semangat,
            dan siap berkembang bersama kami. Jadilah bagian dari tim kami dan
            wujudkan karier yang bermakna.
          </p>
        </div>
      </section>
      <section className="lg:mt-9">
        <Aplikasi />
      </section>
      <Footer />
    </>
  );
};

export default CoilAbu;
